export enum PoType {
  CustomerPortal = "Customer Portal",
  CallCenter = "Call Centre",
  EzView = 'eZView Order'
}

export enum TransactionStatus {
  Created,
  InProcess,
  Sent,
  Delivered,
}

export enum TrackingStatus {
  Default,
  Rejected,
}

export class OrderDetail {
  delivery_quantity: number;
  invoice_quantity: number;
  invoice_value: number;
  order_quantity: number;
  order_value: number;
  principal_code: string;
  principal_name: string;
  product_code: string;
  product_name: string;
  uom: string;
  quantity_order: number;
  quantity_invoice: number;
  total_value: number;
  image_product_url: string;
  image: {
    image_web: string;
    image_mobile: string;
  };
}

export class Transaction {
  file_url: string;
  filename: string;
  order_details: OrderDetail[];
  total_quantity_so: number;
  total_value_so: number;
  total_quantity_invoice: number;
  total_value_invoice: number;
  order_fulfilled: number;
  order_date: Date;
  po_number: string;
  po_type: PoType;
  request_delivery_date: Date;
  ship_address: string;
  ship_code: string;
  ship_name: string;
  sales_order_number: string;
  transaction_state: number;
  term_of_payment: string;
  total: number;
  status: TransactionStatus;
  so_reject_reason_code: TrackingStatus;
  so_reject_reason: string;
  status_return_code: TrackingStatus;
  status_return: string;
  invoice_number: string;
  total_tax: number;
  total_materai: number;
  total_disc: number;
  total_net_value: number;
  total_gross_value: number;
  show_price_detail: boolean;
}

export class B2bTransaction {
  po_no: string;
  customer_id: number;
  customer_desc: string;
  status: number;
  status_text: string;
  filename: string;
  created_date: Date;
  f_created_date: string;
  remarks: string;
}

export enum TrackingB2bStatus {
  Failed,
  Success,
}

export class PoolOrder {
  id: string;
  transactionId: string;
  tempOrderNo: string;
  status: string;
  statusDate: string;
  createdBy: string;
  createdDt: string;
  updatedBy: string;
  updatedDt: string;
  deletedBy: string;
  deletedDt: string
  poNumber: string;
  grandTotal: string;
  customerCode: string;
  customerName: string;
  branchId: string;
  branchName: string;
  ship_Address: string;
  ship_Code: string;
  ship_Name: string;
}

export class TransactionGt {
  acceptedDate: string;
  accountId: string;
  branchCode: string;
  cratedOrderDate: string;
  createdAt: string;
  createdBy: string;
  deliveredDate: string;
  deliveringDate: string;
  descriptionSuratPesanan: string;
  grandTotal: number;
  id: string;
  inProcessDate: string;
  invoiceNo: number;
  poNumber: string;
  requestTimeZone: string;
  salesOrderNumber: string;
  shipAddress: string;
  shipName: string;
  suratPesanan: string;
  temporaryOrderNumber: string;
  totalDiscount: number;
  totalPpn: number;
  totalPrice: number;
  transactionState: number;
  transactionStatus: number;
  updatedAt: string;
  transactionItem: TransactionItemGt[];
}

export class TransactionItemGt {
  createdAt: string;
  createdBy: string;
  createdDate: string;
  deletedAt: string|null;
  deletedBy: string;
  deletedDate: string;
  id: string;
  modifiedBy: string;
  modifiedDate: string;
  netValue: number;
  price: number;
  principalCode: string;
  principalName: string;
  productCategory: string;
  productCode: string;
  productName: string;
  quantity: number;
  totalPrice: number;
  transactionId: string;
  unitOfMeasure: string;
  updatedAt: string;
}